import React , { useState,useEffect} from "react";
import { Line } from 'react-chartjs-2';
import "../style/debtPayOff.css";
import NewLoader from "../../../styled-components/loader/NewLoader";
import moment from "moment";
import { MODULE_API } from "../../../../apis";
export const PayOffTimeline = (props) => {
  const [monthlyPayment, setMonthlyPayment] = useState([]);
  const [extraPayment, setExtraPayment] = useState([]);
  const [transactionPayment, setTransactionPayment] = useState([]);

  const [dataRes, setDataRes] = useState(null);
  const [months, setMonths] = useState(null);
  const [oneTimeFundingData, setOneTimeFundingData] = useState([]);
  const [oneTimeFundingDataUnpaid, setOneTimeFundingDataUnpaid] = useState([]);

  const myData = props.strategy && props.strategy === "Highest Interest First"
  ? props.data && props.data.sort((a, b) => b["Interest Rate"] - a["Interest Rate"])
  : props.strategy && props.strategy === "Lowest Balance First"
    ? props.data && props.data.sort((a, b) => a["Initial Loan Amount"] - b["Initial Loan Amount"])
    : props.data;
  const chartData = [...new Set(props.data && props.data.map(item => item.amount))];
  const chartDataX = [...new Set(props.data && props.data.map(item => item["Maturity Date"]))];
  let datesData= chartDataX && chartDataX.map((item)=>(
    moment(item).format("MMMM Do YYYY")
  ));
  const uniqueModules = [
    ...new Set(props.data && props.data.map((data) => data.module)),
  ];

  // previous data with transactions
  // useEffect(() => {
  //   // using uniqueModules
  //   // const series = uniqueModules && uniqueModules.map(
  //   //   (module) =>
  //   //     props.data &&
  //   //     props.data.reduce((sum, data) => {
  //   //       if (data.module === module) {
  //   //         const amount = parseFloat(data["Monthly Payment"]);
  //   //         return isNaN(amount) ? sum : sum + amount;
  //   //       } else {
  //   //         return sum;
  //   //       }
  //   //     }, 0)
  //   // );
  //   // setMonthlyPayment(series);

  //   // without uniques module
  //   const monthlyPayments = props.data.map(data => parseFloat(data["Monthly Payment"]) || 0);
  //   const loanPayments = props.data.map(data => parseFloat(data["Initial Loan Amount"]) || 0);

  //   setMonthlyPayment(monthlyPayments);

  //   if (props && props.extra) {
  //     const max = Math.max(...monthlyPayments);
  //     const maxWithExtra = max + parseFloat(props.extra);
  //     const extraArray = Array(monthlyPayments.length).fill(maxWithExtra);
  //     console.log("Extra array:",monthlyPayments);
  //     setExtraPayment(extraArray);
  //   }else{
  //     const max = Math.max(...monthlyPayments);
  //     const extraArray = Array(monthlyPayments.length).fill(max);
  //     console.log("Extra array:",monthlyPayment)
  //     setExtraPayment(extraArray);
  //   }
  //   console.log("values from useEffect==>", monthlyPayments);
  //   console.log("props.transaction",props.transaction)
  //   if (props.data && props.transaction) {
  //     console.log("props.transaction inside")
  //     const transactionArray =  props.data && props.data.map(dataItem => {
  //       const transactions = props.transaction.filter(transaction => transaction.itemId === dataItem.id);
  //       const totalTransactionAmount = transactions.reduce((sum, transaction) => sum + transaction.amount, 0);
  //       return totalTransactionAmount === 0 ? 0 : totalTransactionAmount;
  //     });
  //     console.log("Transaction array:", transactionArray);
  //     setTransactionPayment(transactionArray);

  //   }



  // }, [props.data,props.extra, props.transaction, props.strategy]);

  let totalMinimumMonthlyPayment = props.data && props.data.reduce(
    (sum, item) => {
      const monthlyPayment = parseFloat(item['Monthly Payment']);
      return isNaN(monthlyPayment) ? sum : sum + monthlyPayment;
    },
    0
  );
  useEffect(() => {
    if (!props.data || !oneTimeFundingData || !props.extra) {
      console.error("Missing required data.");
      return;
    }
  
    const myData =
    props.strategy && props.strategy === "Highest Interest First"
        ? props.data && props.data.sort((a, b) => b["Interest Rate"] - a["Interest Rate"])
        : props.data && props.data.sort((a, b) => a["Initial Loan Amount"] - b["Initial Loan Amount"]);
  
    if (!myData || myData.length === 0) {
      console.error("No liabilities data.");
      return;
    }
  
    let temp = {};
    let arrData = [];
    let keys = [
      "Month",
      "Snowball",
      ...myData.map((item) => item["Nickname of Liabilities"]),
      "End Balance",
    ];
  
    temp["header"] = keys;
    const arr = myData.map((item) => item["Nickname of Liabilities"]);
    const data = {};
    myData.forEach((item) => {
      const nickname = item["Nickname of Liabilities"];
      let monthlyPayment = item["Monthly Payment"] || 0;
        if (typeof monthlyPayment === 'string') {
            monthlyPayment = monthlyPayment.replace(/[$,]/g, '').trim();
        }
        monthlyPayment = parseFloat(monthlyPayment);
        if (isNaN(monthlyPayment)) {
            monthlyPayment = 0;
        }
        let initialLoanAmount = item["Initial Loan Amount"] || 0;
        if (typeof initialLoanAmount === 'string') {
            initialLoanAmount = initialLoanAmount.replace(/[$,]/g, '').trim();
        }
        initialLoanAmount = parseFloat(initialLoanAmount);
        if (isNaN(initialLoanAmount)) {
            initialLoanAmount = 0;
        }
        let interestRate = item["Interest Rate"] || 0;
        if (typeof interestRate === 'string') {
            interestRate = interestRate.replace(/[$,]/g, '').trim();
        }
        interestRate = parseFloat(interestRate) / 100;
        if (isNaN(interestRate)) {
            interestRate = 0;
        }
      data[nickname] = {
        total: 0,
        data: [],
        ILA: initialLoanAmount,
        InterestRate: interestRate,
        minimum: monthlyPayment,
        active: true,
      };
    });
    let monthlyPayment =  props.extra + (
      myData &&
      myData.reduce((total, item) => {
          let payment = item["Monthly Payment"];
          if (typeof payment === 'string') {
              payment = payment.replace(/[$,]/g, '').trim();
          }
          const parsedPayment = parseFloat(payment);
          return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
      }, 0)
  );
  let endBalance =
      myData &&
      myData.reduce((total, item) => {
          let payment = item["Initial Loan Amount"];
          if (typeof payment === 'string') {
              payment = payment.replace(/[$,]/g, '').trim();
          }
          const parsedPayment = parseFloat(payment);
          return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
      }, 0);
  
    let i = 0;
    let principalPaidSum = 0;
    let startDate = new Date();
    let globalArr = [];
    let newEndBal = endBalance;
    let otpData = {};
    oneTimeFundingData && oneTimeFundingData.forEach(
      (val) => (otpData[moment(val.date).format("MMM-YY")] = val.payment)
    );
    console.log("here in return");
  
    let iterationCount = 0;
    const maxIterations = 2000; // Set a maximum iteration limit
  
    while (Array.isArray(arr) && arr && arr.length > 0 && iterationCount < maxIterations) {
      startDate.setMonth(startDate.getMonth() + 1);
      i++;
      let obj = {
        month: moment(startDate).format("MMM-YY"),
      };
      let snowball = otpData[obj.month]
        ? otpData[obj.month] - totalMinimumMonthlyPayment
        : monthlyPayment -
          Object.values(data).reduce(
            (a, b) => a + (b.active && b.minimum) || 0,
            0
          );
  
      let newsnowball = snowball;
      let principalPaidInIteration = 0;
  
      arr.forEach((e, index) => {
        let element = data[e];
        let monthlyInterestRate = element.InterestRate / 12;
        let interestRatePaid = element.ILA * monthlyInterestRate;
        let principal;
        if (element.ILA <= element.minimum + newsnowball) {
          element.active = false;
          principal = element.ILA;
          let totalPaid = interestRatePaid + principal;
          snowball =
            Math.round((element.minimum + snowball - totalPaid) * 100) / 100;
          newsnowball = snowball;
        } else {
          principal = element.minimum + (newsnowball || 0) - interestRatePaid;
          if (newsnowball > 0) {
            newsnowball = 0;
          }
        }
        obj[e] = Math.round((interestRatePaid + principal) * 100) / 100;
        element.total += Math.round(interestRatePaid * 100) / 100;
        element.ILA -= Math.round(principal * 100) / 100;
        element.data.push({
          month: new Date(startDate.getTime() + i * 30 * 24 * 60 * 60 * 1000),
          totalPaid: Math.round((interestRatePaid + principal) * 100) / 100,
          snowball,
          endBalance: Math.round((endBalance - principalPaidSum) * 100) / 100,
        });
        data[e] = { ...element, data: [...element.data] };
        principalPaidInIteration += Math.round(principal * 100) / 100;
      });
  
      let liabilities = Object.keys(data);
      liabilities.forEach((l) => {
        obj[l] = (!obj[l] && "") || obj[l];
      });
      principalPaidSum += principalPaidInIteration;
      newEndBal -= principalPaidInIteration;
  
      obj["endBalance"] = Math.round(newEndBal * 100) / 100;
      obj["snowball"] = Math.round(snowball * 100) / 100;
  
      globalArr.push({ ...obj });
  
      arr.forEach((element, index) => {
        if (!data[element].active) arr.splice(index, 1);
      });
      console.log("here in in while",arr);
  
      iterationCount++; // Increment iteration count
    }
  
    if (iterationCount >= maxIterations) {
      console.error("Exceeded maximum iteration limit. Terminating loop.");
      return;
    }
  
    console.log("here in outer while");
    globalArr.map((input, index) => {
      let obj = {};
      Object.keys(data).map((e) => (obj[e] = input[e]));
      let tableData = {
        month: input.month,
        snowball: input.snowball,
        ...obj,
        endBalance: input.endBalance,
      };
      arrData.push(Object.values(tableData));
    });
    temp["data"] = arrData;

    let scheduleData= temp && temp.data;
    const months = [];
    const minimumPayments = [];
    const extraPayments = [];

    scheduleData && scheduleData.forEach(row => {
      const month = row[0];
      const firstValue = +row[1]; // Convert to number
      const sum = row.slice(2, -1).reduce((acc, val) => {
        const numVal = parseFloat(val);
        return numVal ? acc + numVal : acc; // Add to accumulator only if val is a valid number
      }, 0);
      console.log("sum",row.slice(2, -1))
      const minimumSum = sum - firstValue;
      const extraSum = minimumSum + firstValue;
      months.push(month);
      extraPayments.push(extraSum);
      minimumPayments.push(minimumSum);
  });
    setMonths(months);
    setExtraPayment(extraPayments);
    setMonthlyPayment(minimumPayments);
    setDataRes(temp);
  }, [props.data, props.strategy, props.extra, oneTimeFundingData]);
  const getOneTimeFundingPayment = async () => {
    try {
      // setLoading(true);
      const response = await MODULE_API.getOneTimeFunding();
      if (response && response.data) {
        setOneTimeFundingData(
          response.data.filter((item) => item.paid === true)
        );
        setOneTimeFundingDataUnpaid(
          response.data.filter((item) => item.paid === false)
        );
        // setLoading(false);
      }
    } catch (error) {
      // setLoading(false);
      console.error("Error getting OneTimeFundingFromServer:", error);
    }
  };
  useEffect(()=>{
    getOneTimeFundingPayment();
  },[]);
  const data = {
    // labels:datesData && datesData,
    labels: months && months, 
    datasets: [
      {
        label: "Minimum Payments",
        data: monthlyPayment && monthlyPayment,
        fill: true,
        lineTension: 1,
        backgroundColor: "#A982FF",
        borderColor: "#A982FF",
        pointBorderWidth: 0,
        pointRadius: 0, 
        pointHoverRadius: 0,
      },
      {
        label: "Extra Payment",
        data:  extraPayment && extraPayment,
        fill: true,
        lineTension: 0,
        backgroundColor: "#61C9FF",
        borderColor: "#61C9FF",
        pointBorderWidth: 0,
        pointRadius: 0, 
        pointHoverRadius: 0,
      },
      // {
      //   label: "Debt Payoff",
      //   data:  transactionPayment && transactionPayment,
      //   fill: false,
      //   borderColor: "#334EFF",
      //   backgroundColor: "#334EFF",
      //   pointBorderColor: "white",
      //   pointBackgroundColor: "#334EFF",
      //   pointHoverBackgroundColor: "#334EFF",
      //   pointHoverBorderColor: "white",
      //   lineTension: 0.1,
      //   borderCapStyle: "butt",
      //   borderDash: [],
      //   borderDashOffset: 0.0,
      //   borderJoinStyle: "miter",
      //   pointHoverRadius: 10,
      //   pointBorderWidth:2,
      //   pointHoverBorderWidth: 2,
      //   pointRadius: 10,
      //   pointHitRadius: 10,
      //   borderWidth: 0.001,
      // },
    ],
  };

  return (
    <div style={{position:"relative"}}>
      <div className="cardHeading">Payoff Timeline</div>
      <div style={{marginTop:"1rem"}}>
      <Line data={data} 
      options={{
        legend: {
          display: true,
        },
        scales: {
            xAxes: [{
                gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                }
            }],
            yAxes: [{
                gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                }   
            }]
        },
        plugins: {
          
        },
      }}
      />
      </div>
      <NewLoader isLoading={props.loading} />
    </div>
  );
};
